import { render, staticRenderFns } from "./Redeem.vue?vue&type=template&id=1a7a25e3&scoped=true"
import script from "./Redeem.vue?vue&type=script&lang=js"
export * from "./Redeem.vue?vue&type=script&lang=js"
import style0 from "./Redeem.vue?vue&type=style&index=0&id=1a7a25e3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a7a25e3",
  null
  
)

export default component.exports